import { render } from "./AllReports.vue?vue&type=template&id=8578e44c&scoped=true"
import script from "./AllReports.vue?vue&type=script&lang=js"
export * from "./AllReports.vue?vue&type=script&lang=js"

import "./AllReports.vue?vue&type=style&index=0&id=8578e44c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8578e44c"]])

export default __exports__